export enum DMS {
    VIS = 'vis',
    D3 = 'd3',
    ENAJO = 'enaio',
    KOMMXWORK = 'kommxwork',
}
